
import React from 'react';
import { Language } from '../../types';
import { TRANSLATIONS } from '../../constants';

interface SettingsHeaderProps {
  language: Language;
  onClose: () => void;
}

const SettingsHeader: React.FC<SettingsHeaderProps> = ({ language, onClose }) => {
  const t = TRANSLATIONS[language];
  return (
    <div className="px-6 py-4 border-b border-slate-100 dark:border-white/5 flex justify-between items-center bg-white/50 dark:bg-white/[0.01] backdrop-blur-md shrink-0">
      <div className="flex items-center gap-3">
        <div className="w-8 h-8 rounded-xl bg-slate-100 dark:bg-white/5 flex items-center justify-center text-slate-500">
          <i className="fas fa-sliders-h text-xs"></i>
        </div>
        <h2 className="text-sm font-black text-slate-800 dark:text-white uppercase tracking-wider">{t.settings}</h2>
      </div>
      <button onClick={onClose} className="w-8 h-8 flex items-center justify-center hover:bg-slate-100 dark:hover:bg-white/5 rounded-full transition-all text-slate-400">
        <i className="fas fa-times text-xs"></i>
      </button>
    </div>
  );
};
export default SettingsHeader;
